import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { canonicalUrl, CANONICAL_HOST } from "../utils/seo";

import BannerAboutUs from "../assets/images/banner-images/banner-company-aboutus.jpg";
import BannerLeadership from "../assets/images/banner-images/banner-company-leadership.jpg";
import BannerWhyUs from "../assets/images/banner-images/banner-why-us.jpg";
import BannerEvents from "../assets/images/banner-images/banner-company-events.jpg";
import BannerNews from "../assets/images/banner-images/banner-news.jpg";
import BannerPartner from "../assets/images/banner-images/banner-partner.jpg";
import BannerCareers from "../assets/images/banner-images/banners-careers.jpg";

import BannerBeFlight from "../assets/images/banner-images/banner-be-flight.jpg";
import BannerBeHotel from "../assets/images/banner-images/banner-be-hotel.jpg";
import BannerBeActivity from "../assets/images/banner-images/banner-be-activity.jpg";
import BannerBeCar from "../assets/images/banner-images/banner-be-car.jpg";
import BannerBeTransfers from "../assets/images/banner-images/banner-be-transfers.jpg";
import BannerInventoryDistribution from "../assets/images/banner-images/banner-inventory-distribution.jpg";
import BannerBackoffice from "../assets/images/banner-images/banner-backoffice.jpg";
import BannerB2bBooking from "../assets/images/banner-images/banner-b2b-booking.jpg";

import BannerTravelAgency from "../assets/images/banner-images/banner-travel-agency.jpg";
import BannerTourOperator from "../assets/images/banner-images/banner-tour-operator.jpg";
import BannerHostAgency from "../assets/images/banner-images/banner-host-agency.jpg";
import BannerBusReservation from "../assets/images/banner-images/banner-bus-reservation.jpg";
import BannerDistribution from "../assets/images/banner-images/banner-distribution.jpg";
import BannerDevelopmentApi from "../assets/images/banner-images/banner-development-api.jpg";
import BannerTravelMobile from "../assets/images/banner-images/banner-travel-mobile-app.jpg";
import BannerTDX from "../assets/images/banner-images/banner-tdx.jpg";
import BannerEnterprise from "../assets/images/banner-images/banner-enterprise.jpg";

import BannerApiFlight from "../assets/images/banner-images/banner-api-flight.jpg";
import BannerApiHotel from "../assets/images/banner-images/banner-api-hotel.jpg";
import BannerApiActivities from "../assets/images/banner-images/banner-api-activities.jpg";
import BannerApiTransfer from "../assets/images/banner-images/banner-api-transfer.jpg";

import BannerEbooks from "../assets/images/banner-images/banner-ebooks.jpg";
import BannerInfographics from "../assets/images/banner-images/banner-infographics.jpg";
import BannerTestimonials from "../assets/images/banner-images/banner-testimonials.jpg";
import BannerCaseStudy from "../assets/images/banner-images/banner-case-study.jpg";
import BannerCustomers from "../assets/images/banner-images/banner-customers.jpg";

import BannerContactUs from "../assets/images/banner-images/banner-contact-us.jpg";
import BannerPrivacyPolicy from "../assets/images/banner-images/banner-privacy-policy.jpg";
import { Link } from "react-router-dom";

const prettify = (segment) =>
  segment
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

const PageHeader = ({ page }) => {
  const [data, setData] = useState();
  const { pathname } = useLocation();
  const pageUrl = canonicalUrl(pathname);

  const segments = pathname.split("/").filter(Boolean);
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: CANONICAL_HOST + "/" },
      ...segments.map((seg, i) => ({
        "@type": "ListItem",
        position: i + 2,
        name: prettify(seg),
        item: canonicalUrl("/" + segments.slice(0, i + 1).join("/")),
      })),
    ],
  };

  const isService =
    pathname.startsWith("/products/") ||
    pathname.startsWith("/solutions/") ||
    pathname.startsWith("/suppliers/");
  const serviceSchema = isService
    ? {
        "@context": "https://schema.org",
        "@type": "Service",
        name: data?.pageTitle,
        description: data?.desscription,
        url: pageUrl,
        provider: {
          "@type": "Organization",
          name: "TravelCarma",
          url: CANONICAL_HOST + "/",
        },
        areaServed: "Worldwide",
      }
    : null;

  const pageData = [
    {
      page: "about-travelcarma",
      pageTitle:
        "AI-First Travel Technology Built on 20+ Years of Product Experience",
      pageSubTitle:
        "We help travel companies AI-enable, manage, extend, and rebuild travel systems without forcing rip-and-replace.",
      bannerImage: BannerAboutUs,
      title: "AI-First Travel Technology Company | About TravelCarma",
      keywords:
        "About TravelCarma, AI-First Travel Technology Company, Travel Technology Company, Travel Software Solutions, Travel API Integration, Supplier Integration, Travel CRM, Back Office Travel System, Bespoke Travel Software Development",
      desscription:
        "TravelCarma is an AI-first enterprise travel technology partner from Avani Cimcon Technologies, helping travel companies AI-enable workflows, manage legacy systems, integrate supplier APIs, and build bespoke travel platforms.",
    },
    {
      page: "leadership-team",
      pageTitle: "Leadership Team",
      bannerImage: BannerLeadership,
      title: "TravelCarma | Travel Technology Company | Leadership Team",
      keywords: "Leadership Team",
      desscription:
        "TravelCarma is one of world's foremost Travel Technology companies lead by experts in both Travel and Software Development. TravelCarma's management team has a combined experience of over hundred years.",
    },
    {
      page: "why-us",
      pageTitle: "Why TravelCarma for AI-First Travel Technology",
      pageSubTitle:
        "Deep travel product experience, practical AI enablement, supplier/API expertise, and bespoke platform engineering without forced rip-and-replace.",
      bannerImage: BannerWhyUs,
      title: "Why TravelCarma | AI-First Travel Technology Company",
      keywords:
        "Why TravelCarma, AI-First Travel Technology Company, Travel Technology Company, Travel Software Solutions, Travel API Integration, Supplier Integration, Travel CRM, Back Office Travel System, Booking Engines, B2B B2C Travel Portals, Bespoke Travel Software Development",
      desscription:
        "See why TravelCarma is trusted for AI-first travel technology, supplier/API integration, legacy travel system modernization, dedicated engineering execution, and bespoke travel platform development.",
    },
    {
      page: "events",
      pageTitle: "Events",
      bannerImage: BannerEvents,
      title:
        "Travel Industry Events, Travel Technology Consulting & Solutions - TravelCarma",
      keywords:
        "Events at TravelCarma, News, participation in Travel Events, exhibits, travel events, travel technology events",
      desscription:
        "Travel Industry Events, Travel Technology Events - TravelCarma is a Unique Blend of Cloud-based Points-Of-Sales solutions, Inventory & Exchange Solutions and Business Networking Components for Travel Companies and Agents.",
    },
    {
      page: "awards",
      pageTitle: "Recognition / Awards ",
      bannerImage: BannerEvents,
      title:
        "TravelCarma Awards - Enterprise Travel Technology Innovation and Industry Recognition",
      keywords:
        "Travel Technology Innovation, Enterprise Platform Engineering, Travel Technology Leadership, Industry Awards, NASSCOM",
      desscription:
        "TravelCarma has been recognized for innovation and excellence in enterprise travel technology, platform engineering, and modernization solutions. Awarded as a finalist for travel technology innovation at NASSCOM EMERGEOUT Conclave and selected as a Top 100 IT Innovator by NASSCOM for enterprise travel technology leadership.",
    },
    {
      page: "news",
      pageTitle: "TravelCarma News",
      pageSubTitle:
        "Follow this page for latest travel technology news and announcements from TravelCarma",
      bannerImage: BannerNews,
      title: "Latest Travel Technology News and Announcements | TravelCarma",
      keywords: "Latest Travel Technology News and Announcements | TravelCarma",
      desscription:
        "Stay updated with our latest travel technology news and announcement including GDSs, technology solutions, travel technology events and more.",
    },
    {
      page: "partner-program",
      pageTitle: "TravelCarma Partner Program",
      bannerImage: BannerPartner,
      title: "Travel Technology Partner Program - TravelCarma",
      keywords:
        "Premier Partner Program, Authorized Sales Agent Partner Program, Referral Partner Program",
      desscription:
        "TravelCarma offer Multiple Partnership Options, Sales Partner in Travel Technology Industry, Provides  Custom Travel Technology Solutions in Travel Businesses for Travel Agency, Agents, Hoteliers and Tour Operators.",
    },
    {
      page: "careers",
      pageTitle: "Careers",
      pageSubTitle:
        "Looking to build a career in travel technology? Join our team!",
      bannerImage: BannerCareers,
      title: "Careers - Travel Technology Company | Online Travel Solutions",
      keywords: "Careers - Travel Technology Company | Online Travel Solutions",
      desscription:
        "Careers - Travel Technology Company | Online Travel Solutions",
    },
    {
      page: "flight-booking-engine",
      pageTitle: "Flight Booking Engine & Airline Integration Modernization",
      pageSubTitle:
        "AI-ready flight booking, GDS connectivity, supplier normalization, and enterprise distribution workflows without forced rip-and-replace.",
      bannerImage: BannerBeFlight,
      title: "Flight Booking Engine | Airline API Integration & Distribution Modernization | TravelCarma",
      keywords:
        "flight booking engine, airline reservation system, online booking software, GDS booking system, online booking engine, online airline reservation system, flight booking system",
      desscription:
        "TravelCarma helps travel companies modernize flight booking engines with airline and GDS API integration, supplier normalization, AI-ready pricing workflows, CRM connectivity, and enterprise distribution capabilities.",
    },
    {
      page: "hotel-booking-engine",
      pageTitle:
        "Hotel Booking Engine & Inventory Modernization",
      pageSubTitle:
        "Modernize hotel booking workflows, supplier integrations, and contracted inventory management with AI-ready data and enterprise distribution layers.",
      bannerImage: BannerBeHotel,
      title: "Hotel Booking Engine | Hotel API Integration & Inventory Modernization | TravelCarma",
      keywords: "Hotel Booking Engine | Online Hotel Reservation System",
      desscription:
        "TravelCarma modernizes hotel booking engines with supplier API integration, contracted inventory workflows, pricing intelligence, CRM connectivity, and enterprise distribution systems.",
    },
    {
      page: "car-booking-engine",
      pageTitle: "Car Rental Booking Engine & Ground Transportation Integration",
      pageSubTitle:
        "Integrate and modernize car rental and transfer booking workflows across portals, CRM, supplier APIs, and back-office systems.",
      bannerImage: BannerBeCar,
      title: "Car Rental Booking Engine | Ground Transportation Integration | TravelCarma",
      keywords: "Car Rental Booking Engine | Car Reservation System",
      desscription:
        "TravelCarma helps travel companies modernize car rental booking engines with supplier integration, pricing workflows, CRM connectivity, and enterprise distribution capabilities.",
    },
    {
      page: "activity-booking-engine",
      pageTitle: "Activity & Sightseeing Booking Engine Modernization",
      pageSubTitle:
        "AI-ready activity booking, supplier aggregation, itinerary workflows, and enterprise distribution integration.",
      bannerImage: BannerBeActivity,
      title:
        "Activity Booking Engine | Sightseeing API Integration & Modernization | TravelCarma",
      keywords:
        "Activity, Sightseeing Booking Engine | Online Excursions Reservation System",
      desscription:
        "TravelCarma modernizes activity and sightseeing booking engines with supplier API integration, itinerary workflows, CRM connectivity, and AI-ready distribution systems.",
    },
    {
      page: "transfers-booking-engine",
      pageTitle: "Transfers Booking Engine & Ground Operations Modernization",
      pageSubTitle:
        "Modernize transfer booking workflows, supplier connectivity, pricing management, and enterprise distribution layers.",
      bannerImage: BannerBeTransfers,
      title: "Transfers Booking Engine | Transfer API Integration & Modernization | TravelCarma",
      keywords:
        "Transfers Booking Engine | Airport Transfers Reservation System",
      desscription:
        "TravelCarma helps travel companies modernize transfer booking engines through supplier API integration, pricing workflows, CRM connectivity, and enterprise distribution systems.",
    },
    {
      page: "inventory-management",
      pageTitle: "Inventory Management & Modernization",
      pageSubTitle:
        "Centralize and modernize rates, availability, and distribution for hotels, activities, transfers, and ground transportation across multi-tenant systems.",
      bannerImage: BannerInventoryDistribution,
      title:
        "Travel Inventory Management Solution | Hotel CRS | Activity CRS | Car Rental CRS",
      keywords:
        "Centrally manage and distribute your contracted inventory with real-time availability and prices for hotels, cars, activities etc",
      desscription:
        "Centrally manage and distribute your contracted inventory with real-time availability and prices for hotels, cars, activities etc",
    },
    {
      page: "back-office",
      pageTitle:
        "Enterprise Back-Office Modernization & Automation",
      bannerImage: BannerBackoffice,
      title:
        "Travel Mid & Back Office Management Software | Travel Agency Back Office",
      pageSubTitle:
        "Modernize back-office workflows, accounting reconciliation, customer management, and operational processes to increase profitability and efficiency.",
      keywords:
        "Travel Mid & Back Office Management Software | Travel Agency Back Office & CRM Solution",
      desscription:
        "An advanced back-office management system for travel agencies and tour operators that helps to manage and automate routine administrative tasks to increased productivity and efficiency.",
    },
    {
      page: "b2b-booking-system",
      pageTitle: "B2B Booking System & Agent Network Modernization",
      pageSubTitle:
        "Modernize B2B agent networks, sub-agent portals, commission management, and multi-tier booking workflows for agencies, wholesalers, and DMCs.",
      bannerImage: BannerB2bBooking,
      title:
        "B2B Booking Engine | B2B Travel Portal Development | B2B Travel Booking system",
      keywords:
        "B2B Travel Booking System, B2B Booking Portal, B2B Travel Booking Engine",
      desscription:
        "TravelCarma's B2B booking system enables travel agencies, wholesalers, and DMCs to manage sub-agent networks with dedicated portal access, credit limits, markup rules, and automated commission management. Integrates with Travel CRM, back-office systems, and supplier APIs for AI-enabled B2B distribution and agent network modernization.",
    },

    {
      page: "travel-agency-software",
      pageTitle:
        "AI-Enabled Travel Agency Software and Platform Modernization",
      pageSubTitle:
        "Modernize agency operations, booking workflows, CRM, back-office systems, supplier integrations, and custom travel platforms without forced rip-and-replace.",
      bannerImage: BannerTravelAgency,
      title:
        "Travel Agency Software | AI-Enabled Travel ERP and Booking Platform | TravelCarma",
      keywords:
        "Travel Agency Software, Travel Software for Travel Agencies, Travel Agency CRM, Travel Booking Engine, B2B Booking Engine, B2C Travel Portal, Travel ERP, Back Office Travel System, Travel API Integration, Supplier Integration, Travel Agency Automation, Travel Management Software",
      desscription:
        "TravelCarma helps travel agencies AI-enable workflows, modernize existing travel agency software, integrate supplier APIs, extend booking engines, CRM, back-office systems, accounting, reconciliation, and quotation workflows, and build bespoke agency platforms.",
    },
    {
      page: "dmc-software",
      pageTitle:
        "AI-Enabled DMC Software and Tour Operator Platform Modernization",
      pageSubTitle:
        "Modernize destination operations, package management, itinerary workflows, supplier integrations, booking engines, and back-office systems without forced rip-and-replace.",
      bannerImage: BannerTourOperator,
      title:
        "DMC Software | Tour Operator Software | AI-Enabled Destination Platform | TravelCarma",
      keywords:
        "DMC Software, Tour Operator Software, Destination Management Software, Itinerary Builder, Travel Package Software, Package Management, Contracted Inventory, Travel Booking Engine, Travel API Integration, Supplier Integration, Travel CRM, Back Office Travel System, Quotation Software",
      desscription:
        "TravelCarma helps DMCs and tour operators AI-enable itinerary, package, quotation, supplier, booking, CRM, and back-office workflows, modernize existing systems, integrate supplier data, and build bespoke destination platforms.",
    },
    {
      page: "host-agency-solution",
      pageTitle:
        "AI-Enabled Host Agency Solution and B2B Agent Network Modernization",
      bannerImage: BannerHostAgency,
      title:
        "Host Agency Solution | Host Agency Software | B2B Agent Network Platform | TravelCarma",
      pageSubTitle:
        "Modernize host agency platforms, B2B/B2C portals, agent workflows, supplier integrations, CRM, commissions, and back-office systems without forced rip-and-replace.",
      keywords:
        "Host Agency Solution, Host Agency Software, Travel Agency Software, B2B Booking Engine, B2C Travel Portal, B2B2C Travel Portal, Travel CRM, Travel Booking Engine, Supplier Integration, Travel API Integration, Agent Management, Travel Back Office System, Commission Management, Markup Management",
      desscription:
        "TravelCarma helps host agencies AI-enable agent workflows, modernize B2B/B2C portals, integrate supplier APIs, manage partner networks, extend CRM and back-office systems, and build bespoke host agency platforms.",
    },
    {
      page: "bus-operator",
      pageTitle: "Bus Operator Platform Modernization and Reservation System Integration",
      pageSubTitle:
        "Modernize bus reservation workflows, route management, seat inventory, ticketing, distribution, CRM, and back-office systems without forced rip-and-replace.",
      bannerImage: BannerBusReservation,
      title:
        "Bus Reservation Software | Bus Operator Platform Modernization | TravelCarma",
      keywords:
        "Bus Operator, Bus Booking Software, Online Bus Reservation System, Bus Booking Engine",
      desscription:
        "TravelCarma helps bus operators modernize reservation systems with route management, seat inventory workflows, pricing control, distribution integration, CRM connectivity, and back-office automation — without replacing existing infrastructure.",
    },
    {
      page: "travel-data-xchange",
      pageTitle: "TDX - Travel API Aggregation Hub",
      bannerImage: BannerTDX,
      title:
        "TDX | Travel Unified API Platform | Travel Content Aggregation and Distribution",
      keywords: "Travel Distribution Switch",
      desscription:
        "Our XML web services based travel switch allows large travel companies to aggregate and distribute data from multiple suppliers through a unified API platform.",
    },
    {
      page: "hajj-umrah",
      pageTitle: "Hajj and Umrah Booking Solution",
      bannerImage: BannerInfographics,
      title: "Hajj & Umrah Booking Software | Hajj & Umrah Booking System",
      keywords: "Hajj & Umrah Booking Software | Hajj & Umrah System",
      desscription:
        "TravelCarma provides an end-to-end Hajj & Umrah Booking System for OTAs and Umrah Operators with real-time connectivity with Maqam GDS",
    },
    {
      page: "inventory-distribution",
      pageTitle:
        "AI-Ready Inventory Distribution and Travel Distribution Modernization",
      pageSubTitle:
        "Modernize contracted inventory, CRS workflows, supplier orchestration, channel management, and distribution APIs without forced rip-and-replace.",
      bannerImage: BannerDistribution,
      title:
        "Inventory Distribution | Travel Distribution System | AI-Ready Travel CRS | TravelCarma",
      keywords:
        "Inventory Distribution, Travel Inventory Distribution, Travel Distribution System, Channel Management, Contracted Inventory, Travel CRS, Supplier Integration, Travel API Integration, Travel Data Xchange, Travel Aggregation, DMC Software, Tour Operator Software, Travel Booking Engine, B2B Booking Engine, B2C Travel Portal",
      desscription:
        "TravelCarma helps travel companies AI-enable inventory workflows, normalize supplier and contracted inventory data, modernize travel distribution systems, extend CRS and channel management platforms, and build bespoke inventory distribution solutions.",
    },
    {
      page: "development-api",
      pageTitle: "AI-Ready Travel API Integration",
      pageSubTitle:
        "Integrate, normalize, and extend supplier/API data across existing travel systems.",
      bannerImage: BannerDevelopmentApi,
      title:
        "Travel API Integration and Development APIs | AI-Ready Travel Data | TravelCarma",
      keywords:
        "Development APIs, Travel API Integration, Travel XML API Integration, Supplier Integration, Travel Technology API, Travel Software Development, AI-Ready Travel Data, Supplier API Normalization, B2B Booking Engine, B2C Travel Portal, Travel CRM, Back Office Travel System, Travel Data Xchange",
      desscription:
        "TravelCarma helps travel companies integrate and normalize supplier/API data, create AI-ready travel data layers, and connect APIs into booking engines, B2B/B2C portals, Travel CRM, and back-office systems.",
    },
    {
      page: "mobile-travel-apps",
      pageTitle: "AI-First Mobile Travel Applications and Platform Integration",
      pageSubTitle:
        "Modernize mobile booking, agent access, customer journeys, and travel workflows without rebuilding your entire platform.",
      bannerImage: BannerTravelMobile,
      title: "AI-First Travel Mobile Applications | Mobile Booking Integration | TravelCarma",
      keywords: "Mobile Travel Applications, Mobile Booking Integration, Travel Mobile Apps, Mobile Agent Access, Travel Booking Apps, Travel CRM Mobile, Back Office Mobile, Supplier API Mobile Integration",
      desscription:
        "TravelCarma helps travel companies build and modernize mobile travel applications integrated with booking engines, supplier APIs, CRM, and back-office systems — without forced rip-and-replace.",
    },
    {
      page: "travel-tech-consulting",
      pageTitle: "AI-First Travel Technology Consulting",
      pageSubTitle:
        "Modernize, AI-enable, integrate, and extend travel systems without forced rip-and-replace.",
      bannerImage: BannerInfographics,
      title: "AI-First Travel Technology Consulting | TravelCarma",
      keywords:
        "Travel Technology Consulting, AI-First Travel Technology Consulting, Travel Technology Company, Travel Software Solutions, Travel API Integration, Supplier Integration, Travel CRM, Back Office Travel System, B2B Booking Engine, B2C Travel Portal, Bespoke Travel Software Development",
      desscription:
        "TravelCarma helps travel companies AI-enable workflows, modernize legacy systems, integrate supplier APIs, deploy dedicated travel technology teams, and build bespoke travel platforms.",
    },
    {
      page: "enterprise-software",
      pageTitle: "Enterprise Travel Technology Modernization",
      pageSubTitle:
        "AI-enable, integrate, manage, and extend enterprise travel systems without forced rip-and-replace.",
      bannerImage: BannerEnterprise,
      title:
        "Enterprise Travel Technology Solutions | AI-First Modernization | TravelCarma",
      keywords:
        "Enterprise Travel Technology, Travel Technology Solutions, Travel Software Solutions, Enterprise Travel Software, Legacy Travel System Modernization, AI-First Travel Technology, B2B Booking Engine, B2C Travel Portal, Travel CRM, Back Office Travel System, Travel API Integration, Supplier Integration, Travel ERP, Bespoke Travel Software Development",
      desscription:
        "TravelCarma helps enterprise travel companies AI-enable existing systems, modernize legacy travel infrastructure, integrate supplier APIs, extend B2B/B2C portals, and build bespoke travel platforms.",
    },

    {
      page: "customers",
      pageTitle: "TravelCarma Customers",
      pageSubTitle:
        "We have 200+ clients in more than 55 countries. Our solutions have been fine-tuned for each of these markets and are being used successfully by travel companies of all sizes, from startups mid-sized travel agencies to large companies.",
      bannerImage: BannerCustomers,
      title:
        "TravelCarma Customers | Travel Agencies | Tour Operators | Hotels | Vehicle Operators",
      keywords:
        "travelcarma clients, travel technology solutions, travel agent software, tour operator software, bus reservation software,Software Development Services, India, testimonials, USA, Europe, Middle East, South East Asia , Africa , online travel technology , global travel customers",
      desscription:
        "We have helped hundreds of Travel Agencies, Tour Operators, Accommodation providers and Vehicle Operators become fully-fledged online travel businesses. We offer Travel Agency software, Hotel Booking Software, Car Rental Software, Bus Reservation Software",
    },
    {
      page: "customer-testimonials",
      pageTitle: "Testimonials",
      pageSubTitle:
        "Customer Satisfaction is the number one priority of our business. We at TravelCarma define our success based on the level of success our clients achieve by using our solutions.",
      bannerImage: BannerTestimonials,
      title:
        "Customer Testimonials & Reviews | TravelCarma Online Travel Solutions",
      keywords:
        "Customer Testimonials & Reviews, TravelCarma Online Travel Solutions",
      desscription:
        "Testimonials / Client Speaks about TravelCarma's Travel Software Solutions, Client Reviews about Travel Booking Software Solutions, Travel Agency Software, Travel Technology Solutions.",
    },
    {
      page: "case-studies",
      pageTitle: "Client Case Studies",
      pageSubTitle:
        "Here are a few examples of how TravelCarma has helped its clients achieve their business goals",
      bannerImage: BannerCaseStudy,
      title:
        "Travel Technology Company | Client Case Studies and Success Stories",
      keywords:
        "Travel Technology Company, Client Case Studies and Success Stories",
      desscription:
        "TravelCarma has helped hundreds of Travel and Tourism companies worldwide evolve their technology. Here are some case studies of our enterprise travel technology partners. ",
    },
    {
      page: "travel-xml-api-integrations",
      pageTitle: "Travel API Integration and Supplier Normalization",
      pageSubTitle:
        "Integrate XML APIs, GDSs, and travel suppliers into AI-ready, booking-ready data layers.",
      bannerImage: BannerApiFlight,
      title:
        "Travel XML API Integration | Supplier Integration | TravelCarma",
      keywords:
        "Travel XML API Integration, Travel API Integration, Supplier Integration, Flight API Integration, Hotel API Integration, Sightseeing API Integration, Transfer API Integration, Travel Supplier API, Travel Technology API, Travel Data Xchange, B2B Booking Engine, B2C Travel Portal, Travel CRM, Back Office Travel System, GDS API Integration, XML Supplier Connectivity",
      desscription:
        "TravelCarma provides travel API integration and supplier/API normalization across GDSs, flights, hotels, transfers, activities, and other travel content for booking engines, B2B/B2C portals, Travel CRM, back-office systems, and AI-ready workflows.",
    },
    {
      page: "flight-api-integration",
      pageTitle: "Flight API Integration",
      pageSubTitle:
        "Integrate and normalize airline, GDS, consolidator, and LCC data for AI-ready flight booking workflows.",
      bannerImage: BannerApiFlight,
      title:
        "Flight API Integration | Airline API and GDS API Integration | TravelCarma",
      keywords:
        "Flight API Integration, Airline API Integration, GDS API Integration, Flight Booking Engine, Travel API Integration, Supplier Integration, Travel XML API Integration, Travel Technology API",
      desscription:
        "TravelCarma helps travel companies integrate and normalize flight APIs, GDSs, consolidators, and LCC data into booking engines, B2B/B2C portals, CRM, and back-office workflows.",
    },
    {
      page: "hotel-api-integration",
      pageTitle: "Hotel API Integration",
      pageSubTitle:
        "Normalize hotel supplier and bedbank data for booking engines, portals, pricing, reporting, and AI-ready workflows.",
      bannerImage: BannerApiHotel,
      title:
        "Hotel API Integration | Hotel XML API Integration | TravelCarma",
      keywords:
        "Hotel API Integration, Hotel XML API Integration, Hotel Booking Engine, Travel API Integration, Supplier Integration, Travel Technology API, B2B Booking Engine, B2C Travel Portal",
      desscription:
        "TravelCarma integrates and normalizes hotel API supplier data from bedbanks, OTAs, and wholesalers into hotel booking engines, B2B/B2C portals, CRM, and back-office systems.",
    },
    {
      page: "sightseeing-api-integration",
      pageTitle: "Activities & Sightseeing API Integration",
      pageSubTitle:
        "Integrate activity and sightseeing supplier APIs into booking-ready and AI-ready travel data layers.",
      bannerImage: BannerApiActivities,
      title:
        "Sightseeing API Integration | Activity API Integration | TravelCarma",
      keywords:
        "Sightseeing API Integration, Activity API Integration, Travel API Integration, Supplier Integration, Travel XML API Integration, Travel Technology API, Activity Booking Engine",
      desscription:
        "TravelCarma helps travel companies integrate and normalize activity and sightseeing API data for booking engines, B2B/B2C portals, recommendations, itinerary workflows, and reporting.",
    },
    {
      page: "transfer-api-integration",
      pageTitle: "Transfers & Car Rental API Integration",
      pageSubTitle:
        "Integrate car rental and transfer supplier APIs into existing travel portals, booking engines, and back-office workflows.",
      bannerImage: BannerApiTransfer,
      title:
        "Transfer API Integration | Car Rental API Integration | TravelCarma",
      keywords:
        "Transfer API Integration, Car Rental API Integration, Travel API Integration, Supplier Integration, Travel XML API Integration, Travel Technology API, Car Booking Engine",
      desscription:
        "TravelCarma integrates and normalizes transfer and car rental APIs for OTAs, DMCs, booking engines, B2B/B2C portals, Travel CRM, and back-office systems.",
    },

    {
      page: "ebooks",
      pageTitle: "TravelCarma Ebooks",
      pageSubTitle:
        "Download our Free e-books for useful tips and tricks on how to grow your Travel Business",
      bannerImage: BannerEbooks,
      title: "Ebooks",
      keywords: "ebooks",
      desscription: "TravelCarma Ebooks",
    },
    {
      page: "infographics",
      pageTitle: "Infographics",
      pageSubTitle:
        "We regularly produce high quality infographics that help travel firms stay abreast.",
      bannerImage: BannerInfographics,
      title:
        "TravelCarma Infographics | Tourism & Travel Technology Infographics",
      keywords:
        "TravelCarma Infographics | Tourism & Travel Technology Infographics",
      desscription:
        "Download our infographics to stay abreast with the latest industry trends and tips & guides on how to run your travel business successfully",
    },
    {
      page: "videos",
      pageTitle: "AI-First Travel Technology Insights and Modernization Discussions",
      pageSubTitle:
        "Explore platform architecture walkthroughs, enterprise modernization strategies, AI-enabled workflows, integration patterns, and client case studies.",
      bannerImage: BannerInfographics,
      title: "Travel Technology Videos | Platform Architecture & Enterprise Insights | TravelCarma",
      keywords: "Travel Technology Videos, Platform Architecture, Enterprise Modernization, AI-Enabled Workflows, Integration Strategy, Travel Technology Insights, Client Case Studies, Travel System Modernization",
      desscription:
        "TravelCarma's video library features travel technology insights, platform architecture walkthroughs, enterprise modernization strategies, AI-enabled workflow discussions, and client case studies for enterprise travel technology teams.",
    },

    {
      page: "faqs",
      pageTitle: "Frequently Asked Questions",
      pageSubTitle:
        "Have questions about our products? You'll find answers to the most common questions we're asked by customers in this section. For more in-depth discussions, please get in touch with us",
      bannerImage: BannerInfographics,
      title: "TravelCarma Frequently Asked Questions",
      keywords:
        "Travel Agency FAQ, Frequently Asked Questions, Travel agency system FAQ, Travel agent system FAQ",
      desscription: "Travel Agency FAQ, Frequently Asked Questions",
    },
    {
      page: "contact-us",
      pageTitle: "Contact Us",
      pageSubTitle:
        "Interested in our solutions ? Simply fill out the form below and we'll get back to you within 24 hours!",
      bannerImage: BannerContactUs,
      title: "Contact Us - TravelCarma Travel Technology Solutions",
      keywords: "Contact Us, Contact TravelCarma",
      desscription:
        "Inquire now for Online Travel Solutions. Email :sales@travelcarma.com, Phone US: +1 904 302 7278, UK: +44 203 051 6811",
    },
    {
      page: "privacypolicy",
      pageTitle: "Privacy and Data Protection Policy",
      bannerImage: BannerPrivacyPolicy,
      title: "Privacy and Data Protection Policy",
      keywords: "Privacy and Data Protection Policy",
      desscription: "Privacy and Data Protection Policy",
    },
    {
      page: "travelcarma-lite",
      pageTitle: "TravelCarma Lite",
      pageSubTitle:
        "Manage and track all your inquiries, customers and bookings from one place",
      bannerImage: BannerTravelAgency,
      title: "FREE Itinerary Builder For Travel Agents | TravelCarma Lite",
      keywords:
        "Manage inquiries, itineraries, customers and accounting on one platform",
      desscription:
        "TravelCarma Lite is a one-stop-solution for travel professionals to manage inquiries, itineraries, customers and accounting on one platform",
    },
  ];

  const getPageTitle = () => {
    let data = "";
    data = pageData.find((x) => x.page === page);
    setData(data);
  };

  useEffect(() => {
    getPageTitle();
  }, []);

  return (
    <React.Fragment>
      <div className="page-title d-flex align-items-center mb-5">
        <div className="container text-center">
          <h1 className="text-white m-0 fw-bold">{data?.pageTitle}</h1>
          {data?.pageSubTitle && (
            <h5 className="text-white mt-2">{data?.pageSubTitle}</h5>
          )}

          {page === "travelcarma-lite" && (
            <Link
              to="https://lite.travelcarma.com"
              target="_blank"
              className="btn btn-primary mt-3"
            >
              {" "}
              Start Free{" "}
            </Link>
          )}
        </div>

        <img
          className="page-title-img"
          src={data?.bannerImage}
          alt={data?.pageTitle}
        />
      </div>

      <Helmet>
        <title>{data?.title}</title>
        <meta name="keywords" content={data?.keywords} />
        <meta name="description" content={data?.desscription} />
        <meta property="og:title" content={data?.title} />
        <meta property="og:description" content={data?.desscription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:site_name" content="TravelCarma" />
        {data?.bannerImage && (
          <meta property="og:image" content={data.bannerImage} />
        )}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={data?.title} />
        <meta name="twitter:description" content={data?.desscription} />
        {data?.bannerImage && (
          <meta name="twitter:image" content={data.bannerImage} />
        )}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
        {serviceSchema && data?.pageTitle && (
          <script type="application/ld+json">
            {JSON.stringify(serviceSchema)}
          </script>
        )}
      </Helmet>
    </React.Fragment>
  );
};

export default PageHeader;
